import { render, staticRenderFns } from "./DeliveryNoteBongkarForm.vue?vue&type=template&id=703fedca&scoped=true&"
import script from "./DeliveryNoteBongkarForm.vue?vue&type=script&lang=js&"
export * from "./DeliveryNoteBongkarForm.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryNoteBongkarForm.vue?vue&type=style&index=0&id=703fedca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703fedca",
  null
  
)

export default component.exports